<div *ngIf="showModal" class="recovery-code-modal-overlay">
  <div class="recovery-code-modal">
    <div class="recovery-code-header">
      <h2>Recovery Code</h2>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>

    <div class="recovery-code-content">
      <p class="description">
        {{'Save your recovery code in a safe place. You can use it to access or delete your bookings if you lose access to your device.' | translate }}'
      </p>

      <div *ngIf="!recoveryCode && !loading" class="code-generation-section">
        <button
          class="btn btn-primary"
          (click)="generateRecoveryCode()"
          [disabled]="loading"
        >
          {{ loading ? 'Generating...' : 'Generate Recovery Code' }}
        </button>
      </div>

      <div *ngIf="recoveryCode" class="code-display-section">
        <div class="recovery-code-box">
          <p class="code-label">Your Recovery Code:</p>
          <p class="code-value">{{ recoveryCode }}</p>
        </div>

        <div class="button-group">
          <button class="btn btn-secondary" (click)="copyToClipboard()">
            {{ copied ? 'Copied!' : 'Copy to Clipboard' }}
          </button>
        </div>

        <div class="warning-box">
          <p>⚠️ <strong>Important:</strong> {{'Keep this code safe and secure. Do not share it with anyone.'| translate}}</p>
        </div>
      </div>

      <div *ngIf="error" class="error-box">
        <p>{{ error }}</p>
      </div>

      <div *ngIf="loading" class="loading-box">
        <p>Generating your recovery code...</p>
      </div>
    </div>

    <div class="recovery-code-footer">
      <button class="btn btn-secondary" (click)="closeModal()">
        {{ recoveryCode ? 'Done' : 'Cancel' }}
      </button>
    </div>
  </div>
</div>
